import React, { useState } from "react";
import { Nav, Logo, NavLink, Bars, NavMenu, NavBtn } from "./HeaderElements";

const Header = ({ toggle }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseOver = () => {
    setIsHovered(true);
  };

  const handleMouseOut = () => {
    setIsHovered(false);
  };

  return (
    <div className="Container" style={{ padding: 0 }}>
      <Nav>
        <Logo to="/">
          <img
            src="/cat.jpg"
            alt="logo"
            className="logo"
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
            style={isHovered ? { transform: 'rotate(360deg)', animation: "spin 2s linear infinite" }
              : { transition: "all 2s ease-in-out" }}
          />
        </Logo>
        <NavMenu>
          <NavLink className="menu-item" to="typogun">
            Typogun
          </NavLink>
          <NavLink className="menu-item" to="illusionlabs">
            Illusion Labs
          </NavLink>
          <NavLink className="menu-item" to="specialization">
            The Game Assembly
          </NavLink>
          <NavLink className="menu-item" to="about">
            About
          </NavLink>
          <NavLink className="menu-item" to="contact">
            Contact
          </NavLink>
        </NavMenu>
        {/* <NavBtn>
          <a
            className="btn PrimaryBtn"
            href="markus_nilsson_resume.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Resume
          </a>
        </NavBtn> */}
        <Bars onClick={toggle} />
      </Nav>
    </div>
  );
};

export default Header;
